<template>
  <div class="online-forms">
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="courseId"
        :value="courseIdName"
        label="报名学科"
        placeholder="请选择报名学科"
        @click="subjectShow = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="subjectShow" position="bottom">
        <van-picker title="选择报名学科" show-toolbar value-key="subject" :columns="subjectColumns" @confirm="subjectConfirm" @cancel="subjectShow = false" />
      </van-popup>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">查询</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { onlinesubject } from "@/server/api.js";
export default {
  data() {
    return {
      courseId: "",
      subjectShow: false,
      courseIdName: "",
      subjectColumns: [],
    };
  },
  mounted() {
    this.subjectList();
  },
  methods: {
    onSubmit() {
      this.onlineTuitionList();
    },

    subjectList() {
      onlinesubject().then((res) => {
        this.subjectColumns = res.data;
      });
    },
    subjectConfirm(value) {
      this.courseIdName = value.subject;
      this.courseId = value.id;
      this.subjectShow = false;
    },
    onlineTuitionList() {
      let courseSelect = [];
      let chooseArr = [];
      courseSelect = this.subjectColumns.find((item) => item.id === this.courseId).tuitionCourseList;
      if (courseSelect && courseSelect.length > 0) {
        courseSelect.forEach((item) => {
          if (item.tuitionCourseConfigList && item.tuitionCourseConfigList.length > 0) {
            item.tuitionCourseConfigList.forEach((tui) => {
              tui.course = item.course;
              tui.courseId = item.id;
            });
          }
          chooseArr.push(...item.tuitionCourseConfigList);
        });
      } else {
        chooseArr = [];
      }
      this.$emit("search", chooseArr);
    },
  },
};
</script>
<style scoped lang="less">
.online-forms {
  /deep/.van-field__control::-webkit-input-placeholder {
    font-size: 26px;
  }
  /deep/.van-form .van-cell {
    padding-left: 0;
  }
  /deep/.van-cell::after {
    left: 0;
  }
}
</style>
